import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchEventDetailsThunk } from '../redux/fetchProjectsThunk';
import html2pdf from 'html2pdf.js';

const AwarenessDetailsTab = ({ item, category_id = 1 }) => {
  const dispatch = useDispatch();
  const contentRef = useRef();
  const faqsSectionRef = useRef();
  const scrollContainerRef = useRef();

  const categoryKey = category_id === 1 ? 'awareness' : 'celebration';

  const { faqs, loading, error } = useSelector(
    (state) => state.projects.eventDetails[categoryKey]
  );
  const [language, setLanguage] = useState('English');
  useEffect(() => {
    console.log("ITEM DEBUG:", item);
  }, []);


  useEffect(() => {
    if (item?.awareness_id) {
      dispatch(fetchEventDetailsThunk({ category_id, event_id: item.awareness_id, language }));
    }
  }, [dispatch, category_id, item?.awareness_id, language]);

  const toggleAccordions = (element, expand) => {
    const collapses = element.querySelectorAll('.accordion-collapse');
    const buttons = element.querySelectorAll('.accordion-button');

    collapses.forEach((collapse) => {
      if (expand) collapse.classList.add('show');
      else collapse.classList.remove('show');
    });

    buttons.forEach((button) => {
      if (expand) {
        button.classList.remove('collapsed');
        button.setAttribute('aria-expanded', 'true');
      } else {
        button.classList.add('collapsed');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  };
  const temporarilyExpandScrollable = (enable) => {
    if (scrollContainerRef.current) {
      if (enable) {
        scrollContainerRef.current.style.maxHeight = 'none';
        scrollContainerRef.current.style.overflowY = 'visible';
      } else {
        scrollContainerRef.current.style.maxHeight = '400px';
        scrollContainerRef.current.style.overflowY = 'auto';
      }
    }
  };

  const handleDownloadPDF = () => {
    if (faqsSectionRef.current) {
      toggleAccordions(faqsSectionRef.current, true);
      temporarilyExpandScrollable(true);
      setTimeout(() => {
        html2pdf()
          .set({
            margin: 0.5,
            filename: `${item.name || 'event-details'}_faqs.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
          })
          .from(faqsSectionRef.current)
          .save()
          .then(() => {
            temporarilyExpandScrollable(false);
            toggleAccordions(faqsSectionRef.current, false);
          });
      }, 100);
    }
  };

  const handlePrint = () => {
    if (faqsSectionRef.current) {
      toggleAccordions(faqsSectionRef.current, true);
      temporarilyExpandScrollable(true);

      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write('<html><head><title>Print FAQs</title>');
      document.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
        printWindow.document.write(`<link rel="stylesheet" href="${link.href}">`);
      });
      printWindow.document.write('</head><body>');
      printWindow.document.write('<div class="container mt-4">');
      printWindow.document.write(faqsSectionRef.current.innerHTML);
      printWindow.document.write('</div></body></html>');
      printWindow.document.close();

      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        toggleAccordions(faqsSectionRef.current, false);
        temporarilyExpandScrollable(false);
      };
    }
  };
  const applyMultiColumn = faqs && faqs.length > 10; // Changed from 20 to 10 for demonstration as per updated request

  if (loading) {
    return <div className="alert alert-info">Loading details...</div>;
  }

  if (error) {
    return <div className="alert alert-danger">Error loading details: {error}</div>;
  }

  return (
    <div className="card card-body" ref={contentRef}>
      {faqs && faqs.length > 0 ? (
        <>
          <div className="d-flex justify-content-between mb-3">
            <h3 className='text-18'>Details related to {item.name}</h3>
            <div className='d-flex gap-2'>
            <select
              className="form-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              style={{ width: '150px', marginRight: '10px' }}
            >
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
            </select>
            <button className="btn btn-primary me-2" onClick={handlePrint}>Print</button>
            <button className="btn btn-primary" onClick={handleDownloadPDF}>Download</button>
          </div>
          </div>

          <div ref={faqsSectionRef}>
            
            {/* Outer scrollable container */}
            <div
              ref={scrollContainerRef}
              style={{
                maxHeight: '400px',
                overflowY: 'auto',
                border: '1px solid #e0e0e0',
                padding: '10px',
              }}
            >
              {/* Inner content container with conditional multi-column */}
              <div
                className="accordion"
                id="eventFaqAccordion"
                style={{  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px' }}
              >
                {faqs.map((faq) => (
                  <div className="accordion-item mb-2 " key={faq.id}>
                    <h2 className="accordion-header m-0 p-0" id={`heading${faq.id}`} style={{borderTop:'1px solid #ddd'}}>
                      <button
                        className="accordion-button collapsed ps-2 pt-0 pb-0 pe-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${faq.id}`}
                        aria-expanded="false"
                        aria-controls={`collapse${faq.id}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div
                      id={`collapse${faq.id}`}
                      className="accordion-collapse collapse"
                      aria-labelledby={`heading${faq.id}`}
                      data-bs-parent="#eventFaqAccordion"
                    >
                      <div
                        className="accordion-body"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="alert alert-info mt-3">
          <h4 className="alert-heading">
            No specific details available yet for "{item.name || item.details}".
          </h4>
          <p>
            This content will be updated dynamically once available.
          </p>
        </div>
      )}
    </div>
  );
};

export default AwarenessDetailsTab;